import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {OrganizationSelectors} from '@store/organization/organization.selectors';
import {NgOptimizedImage} from '@angular/common';
import {SearchControlsComponent} from '@aviary/components/search/search-controls/search-controls.component';
import {Store} from '@ngrx/store';
import {RouterActions, RouterSelectors} from '@store/aviary/aviary.adapter';
import {ViewportSelectors} from '@aviary/store/viewport/viewport.selectors';
import {CATALOG_SEARCH_QUERY_TYPES} from '@store/catalog/catalog.types';
import {QueryTypeUpdate} from '@aviary/components/search/search.types';

@Component({
  selector: 'px-header-logo-bar',
  host: {
    class: 'flex flex-col lg:flex-row lg:justify-between gap-4 lg:gap-8 items-center lg:h-[8.75rem] w-full bg-background pt-3 pb-3 pl-10 ' +
      'pr-10 lg:pr-[clamp(2.5rem,4.5vw,7.5rem)]'
  },
  templateUrl: './header-logo-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SelectPipe, NgOptimizedImage, SearchControlsComponent]
})
export class HeaderLogoBarComponent {
  private readonly store = inject(Store);
  private query: string;
  private queryType: string;
  public readonly organizationSelectors = OrganizationSelectors.Auth;

  public onQueryTypeChange(queryTypeUpdate: QueryTypeUpdate): void {
    this.queryType = queryTypeUpdate.queryType;
    if (this.query) this.search();
  }

  public onSearchSubmit(query: string): void {
    this.query = query;
    this.search();
  }

  private search(): void {
    this.store.dispatch(RouterActions.updateSearchParams(this.query, this.queryType, 'CATALOG_SEARCH', 'searchTarget', true));
  }

  protected readonly viewportSelectors = ViewportSelectors;
  protected readonly CATALOG_SEARCH_QUERY_TYPES = CATALOG_SEARCH_QUERY_TYPES;
  protected readonly routerSelectors = RouterSelectors;
}
